'use client';

import { useMemo } from 'react';
import { timezoneChoiceOptions } from '@/lib/timezone';
import { useRegionConfig } from '@/providers/region-config';

/** The zones timezone pick-lists offer (Admin Settings → Region), in order. */
export function useTimezoneChoices(): { value: string; label: string }[] {
  const { timezoneChoices } = useRegionConfig().config;
  return useMemo(() => timezoneChoiceOptions(timezoneChoices), [timezoneChoices]);
}
